import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PuffLoader } from "react-spinners";
import { postData } from "../../services/Services";
import Button from "../atomic/Button/Button";
import CustomModal from "../atomic/Modal/CustomModal";
import { css } from "@emotion/react";
import styles from "./VerificationOtp.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  formatTimeCountDown,
  phoneNumberLoginOtp,
} from "../../helper/otpPhoneHelper";
import OtpInput from "react-otp-input";
import { OTP_DATA } from "../../constant/otpData";
import { setSendMethod } from "../../redux/action/otpAction";

const VerificationOtp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [otpData, setOtpData] = useState("");
  const [timeLeft, setTimeLeft] = useState(OTP_DATA.OTP_RESEND_TIME); // 3 minutes

  const request_id = searchParams.get("request_id");
  const redirect_uri = searchParams.get("redirect_uri");
  const authorization_code = searchParams.get("authorization_code");
  const twofa_type = searchParams.get("2fa_type");
  const client_id = searchParams.get("client_id");
  const resource_id = searchParams.get("resource_id");
  const isRegister = searchParams.get("isRegister");
  const cancel_uri = searchParams.get("cancel");

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState("");

  // Redux State
  const verifiedPhone = useSelector((state) => state.otpData.phone);
  const sendMethod = useSelector((state) => state.otpData.sendMethod);

  const handleChange = (e) => {
    setOtpData(e);
  };

  const handleResendOtp = async () => {
    setLoading(true);
    const body = {
      authorization_code: authorization_code,
    };
    postData("/v5/auth/login/otp/resend", token, body)
      .then((response) => {
        setLoading(false);
        if (response?.data?.status === 1) {
          setTimeLeft(OTP_DATA.OTP_RESEND_TIME);
        } else if (response?.data?.status === 300071) {
          setOpen(true);
          setMessage(response?.data?.data);
          setTitle("Gagal");
        } else {
          setOpen(true);
          setMessage("Terjadi kesalahan, silahkan coba lagi");
          setTitle("Gagal");
        }
      })
      .catch((error) => {
        setLoading(false);
        setOpen(true);
        setMessage("Terjadi kesalahan, silahkan coba lagi");
        setTitle("Gagal");
      });
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (sendMethod === OTP_DATA.OTP_SEND_SMS) {
      handleVerificationPhoneNumber(OTP_DATA.OTP_SEND_WHATSAPP);
    }
    if (sendMethod === OTP_DATA.OTP_SEND_WHATSAPP) {
      handleVerificationPhoneNumber(OTP_DATA.OTP_SEND_SMS);
    }
  };

  const handleVerificationPhoneNumber = async (method) => {
    setLoading(true);
    const body = {
      phone: method === OTP_DATA.OTP_SEND_SMS ? verifiedPhone : "",
      wa: method === OTP_DATA.OTP_SEND_WHATSAPP ? verifiedPhone : "",
      requestID: request_id,
      redirectURI: redirect_uri,
      resourceID: resource_id,
      "2fa_type": twofa_type ? twofa_type : "",
    };
    postData("/v3/auth/login/pwa/phonenumber", token, body)
      .then((response) => {
        if (response.data.status === 1) {
          const {
            userModel,
            resourceActivation,
            authorization_code,
            is2FAType,
            requestID,
            clientID,
          } = response.data.data;
          dispatch(setSendMethod(method));
          setTimeLeft(OTP_DATA.OTP_RESEND_TIME);
          if (resourceActivation) {
            navigate(
              `/verify-otp?token=${token}&request_id=${requestID}&redirect_uri=${redirect_uri}&resource_id=${resource_id}&isRegister=${isRegister}&cancel=${cancel_uri}&authorization_code=${authorization_code}&2fa_type=${
                is2FAType ? is2FAType : ""
              }&client_id=${clientID}&isLastPage=true`
            );
          } else {
            dispatch(saveUser(userModel));
            navigate(
              `/add-resource?token=${token}&request_id=${requestID}&redirect_uri=${redirect_uri}&resource_id=${resource_id}&isRegister=${isRegister}&cancel=${cancel_uri}&authorization_code=${authorization_code}&2fa_type=${
                is2FAType ? is2FAType : ""
              }&client_id=${clientID}&isLastPage=true`
            );
          }
        } else if (response?.data?.status === 1000037) {
          setOpen(true);
          setMessage(response?.data?.note);
          setTitle("Gagal");
        } else if (response?.data?.status === 1000046) {
          setOpen(true);
          setMessage(response?.data?.data);
          setTitle("Gagal");
        } else {
          setOpen(true);
          setMessage("Terjadi kesalahan, silahkan coba lagi");
          setTitle("Gagal");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("error catch");
        setLoading(false);
        setOpen(true);
        setMessage(
          error?.response?.data?.description
            ? error.response.data.description
            : "Terjadi kesalahan, silahkan coba lagi"
        );
        setTitle("Gagal");
      });
  };

  const handleLoginOtp = async (e) => {
    e.preventDefault();
    if (otpData.length < 6) {
      return;
    }
    handleVerificationOtp();
  };

  const handleVerificationOtp = async () => {
    onRedirectURI();
  };

  const onRedirectURI = () => {
    window.location.replace(
      `${redirect_uri}?&auth_code=${authorization_code}&request_id=${request_id}&is2FAType=${twofa_type}&clientID=${client_id}&otp=${otpData}`
    );
  };

  useEffect(() => {
    // If timeLeft reaches 0, stop the timer
    if (timeLeft <= 0) return;

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000); // Update every 1000ms (1 second)

    // Clean up the interval when the component unmounts or when timeLeft is 0
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  return (
    <div className={styles.loginContainer}>
      {loading && (
        <Box
          position={"absolute"}
          width="100vw"
          top="0"
          left="0"
          height="100vh"
          zIndex="9999999999"
          display="flex"
          alignItems="center"
          justifyContent={"center"}
        >
          <Box
            position={"absolute"}
            width="100vw"
            top="0"
            left="0"
            sx={{ background: "black", opacity: "10%" }}
            height="100vh"
            display="flex"
            alignItems="center"
            justifyContent={"center"}
          ></Box>
          <PuffLoader css={css} color={"black"} loading={loading} size={150} />
        </Box>
      )}
      <Box width="80%" sx={{ height: "100vh" }}>
        {!verifiedPhone && <div>Akses Tidak Diijinkan</div>}
        {verifiedPhone && (
          <Box height={"100%"}>
            <div
              style={{
                width: "100%",
                height: "100%",
                paddingBlock: "20px 0px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                position: "relative",
              }}
            >
              <Typography fontWeight={600} fontSize={22} textAlign={"start"}>
                Verifikasi Kode OTP
              </Typography>
              <Typography
                fontWeight={500}
                fontSize={14}
                textAlign={"justify"}
                color={"#818181"}
              >
                {`Masukkan kode OTP yang dikirim melalui ${sendMethod} ke nomor 
                ponsel terdaftar ${phoneNumberLoginOtp(verifiedPhone)}`}
              </Typography>

              <div className={styles.inputOTPContainer}>
                <OtpInput
                  isInputNum
                  onChange={handleChange}
                  numInputs={6}
                  separator={<span></span>}
                  value={otpData}
                  inputStyle={{
                    outline: "none",
                    border: "none",
                    borderBottom: "1px solid red",
                    margin: "20px 10px",
                    width: "30px",
                    height: "30px",
                    fontSize: "16px",
                  }}
                />
              </div>
              <br />
              {timeLeft === 0 ? (
                <Typography
                  fontWeight={400}
                  fontSize={16}
                  textAlign={"start"}
                  color={"#818181"}
                >
                  {`Belum terima kode? `}
                  <span
                    onClick={() => {
                      handleResendOtp();
                    }}
                    style={{ color: "#D81922", cursor: "pointer" }}
                  >{`Kirim Ulang`}</span>
                </Typography>
              ) : (
                <Typography
                  fontWeight={400}
                  fontSize={16}
                  textAlign={"start"}
                  color={"#818181"}
                >
                  {`Mohon tunggu `}
                  <span style={{ fontWeight: 600, color: "black" }}>
                    {formatTimeCountDown(timeLeft)}
                  </span>
                  {` untuk kirim ulang`}
                </Typography>
              )}
              <br />
              <br />
              <br />

              {timeLeft === 0 && (
                <Typography
                  fontWeight={400}
                  fontSize={16}
                  color={"#36ADE1"}
                  textAlign={"center"}
                  style={{ cursor: "pointer" }}
                  onClick={handleSendOtp}
                >
                  {`Kirim kode melalui ${
                    sendMethod === OTP_DATA.OTP_SEND_SMS
                      ? OTP_DATA.OTP_SEND_WHATSAPP
                      : OTP_DATA.OTP_SEND_SMS
                  }`}
                </Typography>
              )}
              <br />
              <Button
                value={"Masuk"}
                onClick={handleLoginOtp}
                width={`100%`}
                disabled={otpData.length < 6}
                height={`40px`}
              />
            </div>
          </Box>
        )}

        <CustomModal
          open={open}
          onClose={() => setOpen(false)}
          variant={"error"}
          text={message}
          title={title}
        />
      </Box>
    </div>
  );
};

export default VerificationOtp;
